<template>
  <!-- A shared activity or contract: a link from before it could have only one process or third party
       (US 9369 + 9371). Decide where it lives. -->
  <V2SidePanel ref="panel"
               :kind="$t('shared_link.kind')"
               :title="title"
               :intro="$t('shared_link.' + kind + '.intro')"
               :busy="saving"
               qid="shared-link-panel">
    <b-alert v-if="error" show variant="danger">{{ error }}</b-alert>

    <div class="sl-cmp">
      <div class="sl-cmp__c">
        <small>{{ $t('shared_link.lives_in') }}</small>
        <b><font-awesome-icon :icon="parentIcon"/>{{ home ? home.name : '–' }}</b>
      </div>
      <div class="sl-cmp__c">
        <small>{{ $t('shared_link.also_linked') }}</small>
        <b><font-awesome-icon :icon="parentIcon"/>{{ here ? here.name : '' }}</b>
      </div>
    </div>

    <div class="v2-field">
      <span class="v2-field__label">{{ $t('shared_link.' + kind + '.question') }}</span>
      <button type="button" class="sx-option" :class="{ on: action === 'keep' }" qid="shared-link-keep" @click="action = 'keep'">
        <span class="sx-option__grow">{{ $t('shared_link.keep', { name: home ? home.name : '' }) }}<small>{{ $t('shared_link.keep_hint', { name: here ? here.name : '' }) }}</small></span>
        <font-awesome-icon v-if="action === 'keep'" icon="check"/>
      </button>
      <button type="button" class="sx-option" :class="{ on: action === 'move' }" qid="shared-link-move" @click="action = 'move'">
        <span class="sx-option__grow">{{ $t('shared_link.move', { name: here ? here.name : '' }) }}<small>{{ $t('shared_link.move_hint', { name: home ? home.name : '' }) }}</small></span>
        <font-awesome-icon v-if="action === 'move'" icon="check"/>
      </button>
      <button v-if="kind === 'activity'" type="button" class="sx-option" :class="{ on: action === 'split' }" qid="shared-link-split" @click="action = 'split'">
        <span class="sx-option__grow">{{ $t('shared_link.split') }}<small>{{ $t('shared_link.split_hint', { name: item ? item.name : '', process: here ? here.name : '' }) }}</small></span>
        <font-awesome-icon v-if="action === 'split'" icon="check"/>
      </button>
    </div>

    <div v-if="action" class="sx-result">
      <font-awesome-icon icon="clock"/>
      <div>{{ $t('shared_link.logged') }}</div>
    </div>

    <template #foot>
      <b-button variant="secondary" @click="$refs.panel.hide()">{{ $t('shared_link.later') }}</b-button>
      <span class="v2-panel__grow"></span>
      <b-button variant="success" :disabled="!action || saving" qid="shared-link-apply" @click="apply">
        <font-awesome-icon :icon="saving ? 'spinner' : 'check'" :class="{ 'fa-spin': saving }"/> {{ $t('shared_link.apply') }}
      </b-button>
    </template>
  </V2SidePanel>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import V2SidePanel from '@/components/V2SidePanel.vue';

  export default {
    name: 'SharedLinkPanel',
    components: { V2SidePanel },
    props: {
      // activity: shared between processes; contract: shared between third parties
      kind: { type: String, default: 'activity' }
    },
    data() {
      return {
        item: null,
        home: null,
        here: null,
        action: null,
        saving: false,
        error: ''
      };
    },
    computed: {
      title() {
        return this.$t('shared_link.' + this.kind + '.title', { name: this.item ? this.item.name : '' });
      },
      parentIcon() {
        return this.kind === 'activity' ? 'sitemap' : 'building';
      }
    },
    methods: {
      /**
       * @param item the activity or contract: { id, slug, name }
       * @param home where it lives: { id, slug, name }
       * @param here the process or third party it is also linked to: { id, slug, name }
       */
      show(item, home, here) {
        Object.assign(this, { item: item, home: home, here: here, action: null, saving: false, error: '' });
        this.$refs.panel.show();
      },
      apply() {
        let self = this;
        let request = this.kind === 'activity'
          ? piincHttp.post('activities/' + this.item.slug + '/shared', { process: this.here.slug, action: this.action })
          : piincHttp.post('third-parties/' + this.item.slug + '/shared', { vendor_id: this.here.id, action: this.action });
        this.saving = true;
        this.error = '';
        request.then(function(response) {
          self.saving = false;
          self.$toastr('success', self.$t('shared_link.done'));
          self.$refs.panel.hide();
          self.$emit('decided', { action: self.action, item: self.item, home: self.home, here: self.here, result: response.data });
        }, function(error) {
          self.saving = false;
          self.error = (error && error.data && error.data.message) || self.$t('system_hero.panel.error');
        });
      }
    }
  };
</script>
